import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectLoggedIn } from 'services/user/selectors'
import { selectIsPremium, selectUpsellURL } from 'services/premium/selectors'
import { requireAuth } from 'shared/auth'

export default function (ComposedComponent) {

  class RequirePremiumWrapper extends Component {
    static propTypes = {
      isLoggedIn: PropTypes.bool,
      isPremium: PropTypes.bool,
      upsellURL: PropTypes.string,
      requireAuth: PropTypes.func,
      location: PropTypes.object,
    }

    componentDidMount () {
      const { isLoggedIn, isPremium, upsellURL, location } = this.props
      if (!isLoggedIn) {
        requireAuth(location)
      } else if (!isPremium) {
        window.location.href = upsellURL
      }
    }

    render () {
      return (
        <div>
          { this.props.isLoggedIn ? <ComposedComponent {...this.props} /> : null }
        </div>
      )
    }
  }

  const mapStateToProps = (state) => ({
    isLoggedIn: selectLoggedIn(state),
    isPremium: selectIsPremium(state),
    upsellURL: selectUpsellURL(state),
  })

  return connect(mapStateToProps)(RequirePremiumWrapper)
}
